import { render } from "./sent_query_listing.vue?vue&type=template&id=47a783c4"
import script from "./sent_query_listing.vue?vue&type=script&lang=js"
export * from "./sent_query_listing.vue?vue&type=script&lang=js"

import "./sent_query_listing.vue?vue&type=style&index=0&id=47a783c4&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__